function ManageVehicleModal({
  isOpen,
  onClose,
  onEditCurrentPhase,
  onVehicleInfo,
  onTransfer,
  onDelete
}) {
  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ marginTop: 0 }}>Manage Vehicle</h2>

        <p style={descriptionStyle}>
          Manage settings and ownership for this vehicle.
        </p>

        <button onClick={onEditCurrentPhase} style={menuButtonStyle}>
          Edit Current Phase
        </button>

        <button
          onClick={onVehicleInfo}
          style={menuButtonStyle}
        >
        Vehicle Details
        </button>

        <button
          onClick={onTransfer}
          style={menuButtonStyle}
        >
          Transfer Ownership
        </button>

        <button
          onClick={onDelete}
          style={deleteButtonStyle}
        >
          Delete Vehicle
        </button>

        <button
          onClick={onClose}
          style={closeButtonStyle}
        >
          Close
        </button>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,.82)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
  zIndex: 30000
};

const modalStyle = {
  background: "#181818",
  border: "1px solid #333",
  borderRadius: "20px",
  padding: "22px",
  width: "100%",
  maxWidth: "420px",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  color: "white"
};

const descriptionStyle = {
  opacity: .7,
  marginTop: "-6px",
  marginBottom: "10px",
  lineHeight: "1.5"
};

const menuButtonStyle = {
  background: "#e10600",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer",
  textAlign: "left"
};

const deleteButtonStyle = {
  background: "#2a2a2a",
  color: "#ff4d4d",
  border: "1px solid #444",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer",
  textAlign: "left"
};

const closeButtonStyle = {
  background: "#333",
  color: "white",
  border: "none",
  borderRadius: "12px",
  padding: "14px",
  fontWeight: "bold",
  cursor: "pointer"
};

export default ManageVehicleModal;
